import React, { useReducer } from 'react'
import CampaignContext from './campaignContext'
import CampaignReducer from './campaignReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_TEMPLATES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_FETCH_DATA,
    GET_GROUPS_DATA,
    GET_GROUP_USERS,
} from './campaignTypes'

const CampaignState = (props) => {
    const initialState = {
        all_templates: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_campaigns: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_groups: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_group_users: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_template: {
            record: {},
        },

        responseStatus: null,
    }

    const [state, dispatch] = useReducer(CampaignReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getCampaignTemplates = async (
        formData,
        fromVariable = 'GET_CAMPAIGN_TEMPLATES'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'campaignTemplateFetch',
                    formData,
                    '',
                    'campaign'
                ),
            ])
            const from = fromVariable
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TEMPLATES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllCampaigns = async (
        formData,
        fromVariable = 'GET_CAMPAIGNS'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'campaignFetch', formData, '', 'campaign'),
            ])
            const from = fromVariable
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_FETCH_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllCampaignGroups = async (
        formData,
        fromVariable = 'GET_GROUP_CAMPAIGNS'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllCampaignGroups', formData, '', 'group'),
            ])
            const from = fromVariable
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_GROUPS_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const campaignGroupAction = async (
        formData,
        fromVariable = 'CAMPAIGN_GROUP_ACTION'
    ) => {
        try {
            const from = fromVariable
            const [res] = await Promise.all([
                apiCall('post', 'campaignGroupAction', formData, '', 'group'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getCampaignGroupUsers = async (
        formData,
        fromVariable = 'GET_GROUP_USERS'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getCampaignGroupUsers', formData, '', 'group'),
            ])
            const from = fromVariable
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_GROUP_USERS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const campaignGroupUsersAction = async (
        formData,
        fromVariable = 'GROUP_USER_ACTION'
    ) => {
        try {
            const from = fromVariable
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'campaignGroupUsersAction',
                    formData,
                    '',
                    'group'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const campaignTemplateAction = async (
        formData,
        fromVariable = 'CAMPAIGN_TEMPLATES_ACTION'
    ) => {
        try {
            const from = fromVariable
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'campaignTemplateAction',
                    formData,
                    '',
                    'campaign'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const campaignAction = async (
        formData,
        fromVariable = 'CAMPAIGN_ACTION'
    ) => {
        try {
            const from = fromVariable
            const [res] = await Promise.all([
                apiCall('post', 'campaignAction', formData, '', 'campaign'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const campaignSampleMailTrigger = async (
        formData,
        fromVariable = 'CAMPAIGN_SAMPLE_MAIL'
    ) => {
        try {
            const from = fromVariable
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'sentSampleCampaignEmail',
                    formData,
                    '',
                    'campaign'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeCampaignStatus = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'changeStatus'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'changeCampaignStatus',
                    formData,
                    '',
                    'campaign'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <CampaignContext.Provider
            value={{
                all_templates: state.all_templates,
                all_campaigns: state.all_campaigns,
                all_groups: state.all_groups,
                all_group_users: state.all_group_users,
                responseStatus: state.responseStatus,
                getCampaignTemplates,
                getAllCampaigns,
                getAllCampaignGroups,
                campaignGroupAction,
                getCampaignGroupUsers,
                campaignGroupUsersAction,
                campaignAction,
                changeCampaignStatus,
                campaignTemplateAction,
                campaignSampleMailTrigger,
                clearResponse,
            }}
        >
            {props.children}
        </CampaignContext.Provider>
    )
}

export default CampaignState
